import React, { lazy } from "react";
import Header from "../components/Header";
import { connect } from "react-redux";
import {
  GET_ME,
  GET_EXERCISES,
  GET_RECENT_EXERCISES,
  WORKER_START,
} from "../constants/action-types";
import fetchState from "../constants/fetch-state";
import { HotKeys } from "react-hotkeys";
import { isMac, isWindows } from "../services/platform";
import { isMobile } from "react-device-detect";
import { Outlet } from "react-router";
import { sendAppLaunchedEvent } from "../data/app-event/actions";
import * as Sentry from "@sentry/browser";
import { configurePusher } from "pusher-redux";
import store from "../store";
import { getAbsoluteUrl } from "../services/utils";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";

const DownloadClientApp = lazy(() =>
  import("../scenes/misc/components/DownloadClientApp"),
);
const Chat = lazy(() => import("../scenes/messaging"));

let map = {
  moveUp: "up",
  moveDown: "down",
  moveRight: "right",
  moveLeft: "left",
  esc: "esc",
  search: "/",
  return: "return",
  tab: "tab",
  del: ["del", "backspace"],
};
if (isMac()) {
  map.copy = "command+c";
  map.paste = "command+v";
} else if (isWindows()) {
  map.copy = "ctrl+c";
  map.paste = "ctrl+v";
}
configurePusher(store, process.env.PUSHER_KEY, {
  // configurePusher(store, "5523f9ce1866b6f328c6", {
  cluster: "us2",
  authEndpoint: getAbsoluteUrl("/pusher_tokens/new"),
});

class App extends React.Component {
  constructor(props) {
    super(props);
    this.didSetUserContext = false;
    this.didSendAppLaunchEvent = false;
    this.didLoadExerciseDataset = false;
  }

  componentDidMount = () => {
    if (this.props.me.fetchState !== fetchState.LOADED) {
      console.log("not loaded, should fetch me", this.props.me.fetchState);
      this.props.getMe();
    }
    if (this.props.me.fetchState === fetchState.LOADED) {
      console.log("loaded, should fetch me", this.props.me.fetchState);
      this.props.startWorker();
    }
  };

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    if (nextProps.me.fetchState === fetchState.LOADED) {
      if (!nextProps.isExerciseDatasetLoaded && !this.didLoadExerciseDataset) {
        this.props.loadExerciseDataset();
        this.didLoadExerciseDataset = true;
      }
      if (!this.didSendAppLaunchEvent) {
        this.props.sendAppLaunchEvent();
        this.didSendAppLaunchEvent = true;
      }
    }
    if (!this.didSetUserContext && this.props.me.state === fetchState.LOADED) {
      this.didSetUserContext = true;
      Sentry.configureScope((scope) => {
        scope.setUser({
          email: nextProps.me.email,
        });
      });
    }
    if (
      this.props.me.fetchState !== fetchState.LOADED &&
      nextProps.me.fetchState === fetchState.LOADED
    ) {
      this.props.startWorker();
    }
  };

  showMenu = () => {};

  render = () => {
    const styles = {
      container: {
        margin: !isMobile ? "57px 0px 0px 0px" : "57px 0px 0px 0px",
      },
    };

    return (
      <HotKeys keyMap={map}>
        <div>
          {this.props.me.fetchState === fetchState.LOADED &&
            this.props.me.is_client && <DownloadClientApp />}
          {this.props.me.fetchState === fetchState.LOADED &&
            !this.props.me.is_client && (
              <div>
                <Header
                  onMenuClicked={this.showMenu}
                  appTitle={this.props.appTitle}
                />
                <div style={styles.container}>
                    <DndProvider backend={HTML5Backend}>
                    <Outlet />
                    </DndProvider>
                </div>
              </div>
            )}
          {this.props.me.fetchState === fetchState.LOADED && <Chat />}
        </div>
      </HotKeys>
    );
  };
}

const mapStateToProps = (state) => ({
    me: state.me,
    isExerciseDatasetLoaded: state.orderedExercises.length > 0,
    appTitle: state.appTitle,
});

const mapDispatchToProps = (dispatch) => ({
  getMe: () => dispatch({ type: GET_ME.REQUEST }),
  startWorker: () => dispatch({ type: WORKER_START }),
  loadExerciseDataset: () => {
    dispatch({ type: GET_EXERCISES.REQUEST });
    dispatch({ type: GET_RECENT_EXERCISES.REQUEST });
  },
  sendAppLaunchEvent: () => dispatch(sendAppLaunchedEvent()),
});

const ConnectedApp = connect(mapStateToProps, mapDispatchToProps)(App);
export default ConnectedApp;
